import { ToggleableNameValuePair } from './modules/main/models/name-value-pair.model';

export const flatCategories = (categories: ToggleableNameValuePair[]) => {
  let children: ToggleableNameValuePair[] = [];
  return categories
    .map((category) => {
      if (category.innerGroups && category.innerGroups.length) {
        children = [...children, ...category.innerGroups];
      }
      return category;
    })
    .concat(children.length ? flatCategories(children) : children);
};
